import { IMenuItem } from "./navigation.model";
export let adminMenu: IMenuItem[] = [
  {
    module: ["Dashboard"],
    name: "Dashboard",
    type: "link",
    state: "dashboard",
  },
  {
    module: ["User Management"],
    name: "Users Management",
    type: "link",
    state: "user-management",
  },
  {
    module: ["Ads Management"],
    name: "Ads Management",
    type: "link",
    state: "ads-management",
  },
  {
    module: ["Package Details"],
    name: "Package Details",
    type: "link",
    state: "package-details",
  },
  {
    module: ["Payment Transaction"],
    name: "Payment Transaction",
    type: "link",
    state: "payment-transaction",
  },
  {
    module: ["Redeem Users"],
    name: "Redeem Users",
    type: "link",
    state: "redeem-users",
  },
  {
    module: ["Feedback"],
    name: "Feedback",
    type: "link",
    state: "feedback",
  },
  {
    module: ["Reports"],
    name: "Reports",
    type: "dropDown",
    state: "",
    sub: [
      {
        module: ["User Reports"],
        name: "User Reports",
        type: "link",
        state: "reports/user-reports",
      },
      {
        module: ["Ads Reports"],
        name: "Ads Reports",
        type: "link",
        state: "reports/ads-reports",
      },
      {
        module: ["Payment Transaction Reports"],
        name: "Payment Transaction Reports",
        type: "link",
        state: "reports/payment-transaction-reports",
      },
    ],
  },
  {
    name: "Master Settings",
    type: "link",
    state: "settings/category",
    sub: [
      {
        name: "Category & Subcategory",
        type: "link",
        module: ["court"],
        state: "category",
      },
      {
        name: "Brand",
        type: "link",
        module: ["court"],
        state: "brand",
      },
      {
        name: "Model",
        type: "link",
        module: ["court"],
        state: "model",
      },
      {
        name: "Hardware",
        type: "link",
        module: ["court"],
        state: "hardware",
      },
      {
        name: "Customized Questions",
        type: "link",
        module: ["court"],
        state: "customized-questions",
      },
      {
        name: "Redeem Cost",
        type: "link",
        module: ["court"],
        state: "redeem-cost",
      },
      {
        name: "Change Password",
        type: "link",
        module: ["court"],
        state: "change-password",
      },
    ],
  },
];
